// client/src/components/common/Footer.js
import React from "react";
import { useTranslation } from "react-i18next";

// Social Media URLs
const SOCIAL_URLS = {
    facebook: "https://www.facebook.com/profile.php?id=61582602573041",
    instagram: "https://www.instagram.com/telodirectory/",
    tiktok: "https://www.tiktok.com/@telodirectory",
    email: "mailto:telo.directory@gmail.com"
};

const Icon = {
    ArrowUp: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M12 4l-8 8h6v8h4v-8h6z" fill="currentColor" />
        </svg>
    ),
    Mail: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 4l-8 5-8-5" stroke="currentColor" strokeWidth="2" fill="none" />
        </svg>
    ),
    Pin: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M12 2C8.686 2 6 4.686 6 8c0 4.477 6 14 6 14s6-9.523 6-14c0-3.314-2.686-6-6-6zm0 8.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" fill="currentColor" />
        </svg>
    ),
    Facebook: () => (
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
    ),
    Instagram: () => (
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
        </svg>
    ),
    TikTok: () => (
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
        </svg>
    )
};

const Footer = () => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <footer className="footer" role="contentinfo">
            <div className="footer-container">
                <div className="footer-content">
                    {/* Brand Section */}
                    <div className="footer-brand">
                        <h3 className="footer-logo">{t("footer.brand", "TELO Directory")}</h3>
                        <p className="footer-description">
                            {t("footer.description", "Find and share local businesses.")}
                        </p>
                    </div>

                    {/* Quick Links - Hidden on mobile */}
                    <nav className="footer-section footer-links-section" aria-label={t("footer.quickLinks", "Quick Links")}>
                        <h4 className="footer-title">{t("footer.quickLinks", "Quick Links")}</h4>
                        <ul className="footer-links">
                            <li>
                                <button onClick={scrollToTop} className="footer-link-button" aria-label={t("footer.backToTop", "Back to top")}>
                                    <Icon.ArrowUp />
                                    <span>{t("footer.backToTop", "Back to top")}</span>
                                </button>
                            </li>
                            <li>
                                <a href="/send-listing">{t("footer.listBusiness", "List Your Business")}</a>
                            </li>
                        </ul>
                    </nav>

                    {/* Contact & Social */}
                    <div className="footer-section">
                        <h4 className="footer-title">{t("footer.connectWithUs", "Connect with us")}</h4>
                        <div className="footer-contact">
                            <p className="contact-item">
                                <span className="contact-icon" aria-hidden="true"><Icon.Mail /></span>
                                <a href="mailto:telo.directory@gmail.com">telo.directory@gmail.com</a>
                            </p>
                            <p className="contact-item">
                                <span className="contact-icon" aria-hidden="true"><Icon.Pin /></span>
                                {t("footer.location", "Georgia")}
                            </p>
                        </div>
                        <div className="footer-social">
                            <a
                                href={SOCIAL_URLS.facebook}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-social-link"
                                aria-label="Facebook"
                            >
                                <Icon.Facebook />
                            </a>
                            <a
                                href={SOCIAL_URLS.instagram}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-social-link"
                                aria-label="Instagram"
                            >
                                <Icon.Instagram />
                            </a>
                            <a
                                href={SOCIAL_URLS.tiktok}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-social-link"
                                aria-label="TikTok"
                            >
                                <Icon.TikTok />
                            </a>
                            <a href={SOCIAL_URLS.email} className="footer-social-link" aria-label="Email">
                                <Icon.Mail />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Mobile-only links */}
                <div className="footer-mobile-links">
                    <button onClick={scrollToTop} className="footer-mobile-button" aria-label={t("footer.backToTop", "Back to top")}>
                        <Icon.ArrowUp />
                        <span>{t("footer.backToTop", "Back to top")}</span>
                    </button>
                    <a href="/send-listing">{t("footer.listBusiness", "List Your Business")}</a>
                </div>

                {/* Bottom Bar */}
                <div className="footer-bottom">
                    <p className="footer-copyright">
                        &copy; {currentYear} {t("footer.copyright", "All rights reserved.")}
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;

